import { useEffect } from 'react';
import Axios from 'axios';
import { MapRef } from 'react-map-gl/maplibre';
import { useAtomValue, useSetAtom } from 'jotai';

import { Coordinate } from '../job-explorer.types';
import { getUserApproxCoordinatesAtom, setUserApproxCoordinatesAtom } from '../job-explorer-map.atoms';
import { searchBarUrlParamsAtom } from '../job-explorer-filters.atoms';

const APPROX_COORDINATES_API = 'http://ip-api.com/json/?fields=lat,lon';

export const useUserCoordinates = ({ map }: { map: MapRef }) => {
  const locationUrlParams = useAtomValue(searchBarUrlParamsAtom).locationUrlParams;
  const userApproxCoordinates = useAtomValue(getUserApproxCoordinatesAtom);
  const setUserApproxCoordinates = useSetAtom(setUserApproxCoordinatesAtom);

  useEffect(() => {
    if (userApproxCoordinates || !map || locationUrlParams) return;

    const getCoordinates = async () => {
      try {
        const data = (await Axios.get<Coordinate>(APPROX_COORDINATES_API))?.data;
        setUserApproxCoordinates(data);
        map.flyTo({
          center: [data.lon, data.lat],
          duration: 2000,
          zoom: 5,
        });
      } catch (error) {
        console.error(`Error fetching user coordinates from ${APPROX_COORDINATES_API}`, error);
      }
    };

    getCoordinates();
  }, [locationUrlParams, map, setUserApproxCoordinates, userApproxCoordinates]);
};
